import React, { useState, useEffect } from 'react';
import { Card, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Container, Row, Col, Alert } from 'react-bootstrap'
import HR from '../Components/HR';
import { Link } from "react-router-dom";
import { adjustData, alertTexts } from '../Data/data';
import Paragraph from '../Components/Paragraph';

const AdjustTotal = (props) => {
    const [selectedItems, setSelectedItems] = useState([])
    const [show, setShow] = useState(false)

    // Vakiot määrittämään valintamäärien rajat
    const MIN_SELECTED = 5
    const MAX_SELECTED = 10

    // Funktio huolehtimaan alertin piilottamisesta ja valinnan tekemisestä sekä siihen liittyvistä muotoiluista
    const addSelectedItem = (item, event, id) => {
        setShow(false)
        if(event.code == null || event.code === "Enter") {
            if (selectedItems.includes(item)) {
                setSelectedItems(selectedItems => selectedItems.filter(sItem => sItem !== item))
                document.getElementById(id).setAttribute('aria-selected', false)
                return 
            } 
            if (selectedItems.length >= MAX_SELECTED) return
            setSelectedItems([...selectedItems, item])
            document.getElementById(id).setAttribute('aria-selected', true)
        }
    }

    // Funktio huolehtimaan tavoitteiden vahvistamisesta ja siirtämisestä tulokseen sekä alertin näyttämisestä
    const handleSubmit = (e, confirmed) => { 
        if(!confirmed && selectedItems.length < MIN_SELECTED) {
            e.preventDefault()
            setShow(true)
            return
        }
        props.setTargetList(selectedItems)
    }

    // Tilakoukku huolehtimaan focuksesta
    useEffect(() => {
        if(show) {
            document.getElementById("selection-alert").focus()
            window.scrollTo(0, 350)
        } else {
            document.getElementById("info").focus()
            window.scrollTo(0, 0)
        }
      }, [show])

    return (
        <Container role="main" className="content" fluid>
            <Row className="pb-2">
                <Col >
                    <Card border='dark' className='w-50 m-auto adjustTotalHelp'>
                        <Card.Body>
                            <Card.Text id="info" title="Ohjeet" tabIndex="0">{adjustData.help.totalInfo}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className=" p-3" >
                <Alert id="selection-alert" show={show} variant="warning" className='w-50 m-auto adjustSelectAlert' tabIndex="0">
                    <Alert.Heading>{alertTexts.selectedAlert.header}</Alert.Heading>
                    <Paragraph text={alertTexts.selectedAlert.text}/>
                    <HR />
                    <Link to={adjustData.links.toResults} title={alertTexts.selectedAlert.title} className="btn mainButton m-2" onClick={(e) => handleSubmit(e, true)}>{alertTexts.selectedAlert.confirmButton}</Link>
                </Alert>
            </Row>
            <Row>
                <Col>
                    <Card border='dark' className='mb-2'>
                        <Card.Body className='adjustTable'>
                            <Card.Title title={selectedItems.length + '/' + MAX_SELECTED + ' valintaa.'} tabIndex="0">
                                { adjustData.tableHeaders.goalsPosHeader }
                            </Card.Title>
                            <HR />
                            <ListGroup role="listbox" aria-multiselectable="true">
                                {props.plusList.map((item, index) => {
                                    return <ListGroupItem aria-selected="false" key={'TH' + index} id={'TV' + index} role="option" className={`targetItem ${ selectedItems.includes(item) ? 'choiceSelected' : '' }`} onClick={(e) => addSelectedItem(item, e, 'TV' + index) } onKeyPress={(e) => addSelectedItem(item, e, 'TV' + index)} tabIndex="0" >{item}</ListGroupItem>
                                })}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card border='dark' className='mb-2'>
                        <Card.Body className='adjustTable'>
                            <Card.Title title={selectedItems.length + '/' + MAX_SELECTED + ' valintaa.'} tabIndex="0">
                                { adjustData.tableHeaders.goalsNegHeader }
                            </Card.Title>
                            <HR />
                            <ListGroup role="listbox" aria-multiselectable="true">
                                {props.minusList.map((item, index) => {
                                    return <ListGroupItem aria-selected="false" key={'TH' + index}  id={'TH' + index} role="option" className={`targetItem ${ selectedItems.includes(item) ? 'choiceSelected' : '' }`} onClick={(e) => addSelectedItem(item, e, 'TH' + index) } onKeyPress={(e) => addSelectedItem(item, e, 'TH' + index)} tabIndex="0" >{item}</ListGroupItem>
                                })}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='adjustBtn2 w-25 m-auto mt-4'>
                <Link to={adjustData.links.toResults} title={alertTexts.selectedAlert.title} className="btn mainButton" onClick={(e) => handleSubmit(e, false)}>{adjustData.buttons.confirmOne}</Link>
            </Row>   
        </Container>
    );
};

export default AdjustTotal;